
{
  "actions": {
    "close": "Close"
  },
  "logo-alt": "Owner Logo"
}
